import range from 'lodash.range';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../Icon/Icon';
import Page from './components/Page';
import ShortcutLink from './components/ShortcutLink';
import State from './components/State';
import Summary from './components/Summary';
import Pagination from './Pagination';
var DEFAULT_PER_PAGE = 20;

// TODO: Consolidate these and move them to their own file (as a single component)
var FirstPageLink = _ref => {
  var disabled = _ref.disabled,
      page = _ref.page,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(ShortcutLink, {
    name: "first",
    page: page,
    disabled: disabled,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "angle-double-left"
  }));
};

FirstPageLink.displayName = "FirstPageLink";

var PrevPageLink = _ref2 => {
  var disabled = _ref2.disabled,
      page = _ref2.page,
      onClick = _ref2.onClick;
  return /*#__PURE__*/React.createElement(ShortcutLink, {
    name: "previous",
    page: page,
    disabled: disabled,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "angle-left"
  }));
};

PrevPageLink.displayName = "PrevPageLink";

var NextPageLink = _ref3 => {
  var disabled = _ref3.disabled,
      page = _ref3.page,
      onClick = _ref3.onClick;
  return /*#__PURE__*/React.createElement(ShortcutLink, {
    name: "next",
    page: page,
    disabled: disabled,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "angle-right"
  }));
};

NextPageLink.displayName = "NextPageLink";

var LastPageLink = _ref4 => {
  var disabled = _ref4.disabled,
      page = _ref4.page,
      onClick = _ref4.onClick;
  return /*#__PURE__*/React.createElement(ShortcutLink, {
    name: "last",
    page: page,
    disabled: disabled,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "angle-double-right"
  }));
};

LastPageLink.displayName = "LastPageLink";
var linkPropTypes = {
  disabled: PropTypes.bool,
  page: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired
};
FirstPageLink.propTypes = linkPropTypes;
PrevPageLink.propTypes = linkPropTypes;
NextPageLink.propTypes = linkPropTypes;
LastPageLink.propTypes = linkPropTypes;

/**
 * A component that generates a set of links that can be used for pagination.  Link selection is
 * communicated via the `onClick` callback.
 */
var Paginator = _ref5 => {
  var currentPage = _ref5.currentPage,
      _ref5$perPage = _ref5.perPage,
      perPage = _ref5$perPage === void 0 ? DEFAULT_PER_PAGE : _ref5$perPage,
      size = _ref5.size,
      summary = _ref5.summary,
      totalItems = _ref5.totalItems,
      onClick = _ref5.onClick;
  var paginationState = new State(currentPage, totalItems, perPage);

  var _paginationState$curr = paginationState.currentItemRange(),
      from = _paginationState$curr.from,
      to = _paginationState$curr.to;

  var rangeStart = paginationState.pageRange.from;
  var rangeEnd = paginationState.pageRange.to + 1;
  var pages = range(rangeStart, rangeEnd).map(page => /*#__PURE__*/React.createElement(Page, {
    key: page,
    page: page,
    current: currentPage === page,
    onClick: onClick
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column flex-sm-row-reverse justify-content-between align-items-center mb-3"
  }, /*#__PURE__*/React.createElement("div", null, paginationState.totalPages > 1 && /*#__PURE__*/React.createElement(Pagination, {
    size: size,
    listClassName: "m-0 p-0 mb-2 mb-sm-0 border-0 flex-row"
  }, /*#__PURE__*/React.createElement(FirstPageLink, {
    page: 1,
    disabled: !paginationState.showPrevious(),
    onClick: onClick
  }), /*#__PURE__*/React.createElement(PrevPageLink, {
    page: currentPage - 1,
    disabled: !paginationState.showPrevious(),
    onClick: onClick
  }), pages, /*#__PURE__*/React.createElement(NextPageLink, {
    page: currentPage + 1,
    disabled: !paginationState.showNext(),
    onClick: onClick
  }), /*#__PURE__*/React.createElement(LastPageLink, {
    page: paginationState.totalPages,
    disabled: !paginationState.showNext(),
    onClick: onClick
  }))), summary || /*#__PURE__*/React.createElement(Summary, {
    size: size,
    from: from,
    to: to,
    totalItems: totalItems,
    className: "m-0"
  }));
};

Paginator.displayName = "Paginator";
Paginator.propTypes = {
  currentPage: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  perPage: PropTypes.number,
  size: PropTypes.oneOf(['sm', 'lg']),
  summary: PropTypes.node,
  totalItems: PropTypes.number.isRequired
};
Paginator.displayName = 'Paginator';
export default Paginator;